import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CompanyRow from "./companyRow";
import moment from "moment";

const FulfilmentCardDetail = props => {
  const {
    // companies,    
    isFulfilmentNotCompleted,
    companies
  } = props;

  return (
    <div className={"fulfilment-card-detail"}>
      <div className={"fulfilment-detail-date"}>
        {moment(companies[0].fulfilmentDeadline).format("D MMMM YYYY")}
        {moment(companies[0].fulfilmentDeadline).isBefore() &&
          (isFulfilmentNotCompleted) &&
          <div className={"fulfilment-card-expired"}>
            <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
          </div>
        }
      </div>
      <div className={"fulfilment-detail-title"}>
        {companies[0].fulfilmentName}
      </div>
      <div className={"fulfilment-detail-companies-container"}>
        {companies.map(el =>
          <CompanyRow key={"fulfilment-detail-companyRow-" + el.fulfilmentId + "_" + el.customerId} date={companies[0].fulfilmentDeadline} company={el} />)}
      </div>
    </div>
  );
};

export default FulfilmentCardDetail;
